import { Box, Container, Typography } from "@mui/material";
import { ReactElement } from "react";

const NotFoundPage = (): ReactElement => (
  <Box className="center-content">
    <Container maxWidth="md" className="p-10">
      <Typography align="center" color="textPrimary" variant="h4">
        404: The page you are looking for isn’t here
      </Typography>
      <Typography align="center" color="textPrimary" variant="subtitle2">
        You either tried some shady route or you came here by mistake. Whichever
        it is, try using the navigation
      </Typography>
      <Box sx={{ textAlign: "center" }}>
        <img
          alt="Under development"
          src="/images/not-found.png"
          style={{
            marginTop: "2rem",
            background: "black",
            borderRadius: "4%",
            maxWidth: "100%",
          }}
        />
      </Box>
    </Container>
  </Box>
);

export default NotFoundPage;
